module.exports = __webpack_public_path__ + "static/media/wcgPatio.6468fa66.jpg";